import { toast } from "react-toastify";

// import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
// import { storage } from "../conf/firebase";

import { v4 } from "uuid";

export function getBadgeVariant(value) {
  switch (value.toUpperCase()) {
    case "PENDING":
      return "warning";
    case "DEFAULT":
      return "success";
    case "ACTIVE":
      return "light";
    case "disabled":
      return "danger";
    case "CONFIRMED":
      return "info";
    case "DRAFT":
      return "secondary";
    case "SAVED":
      return "secondary";
    default:
      return "primary";
  }
}

export async function uploadFilesToFirebase(files) {
  if (files.length === 0) return console.log("no files");

  // return await Promise.all(
  //   files.map(async (file) => {
  //     const name = v4() + file.name;
  //     const fileRef = ref(storage, name);
  //     return await (async function () {
  //       const id = toast.loading(`uploading ${file.name}`);
  //       try {
  //         const {
  //           metadata: { fullPath },
  //         } = await uploadBytes(fileRef, file);

  //         toast.update(id, {
  //           type: "success",
  //           render: `Uploaded ${file.name}`,
  //           isLoading: false,
  //           autoClose: 1000,
  //         });
  //         const url = await getDownloadURL(ref(storage, fullPath));
  //         return { url, name: file.name };
  //       } catch (error) {
  //         toast.update(id, {
  //           type: "error",
  //           render: "Le téléchargement a échoué",
  //           isLoading: false,
  //           autoClose: 1000,
  //         });
  //       }
  //     })();
  //   })
  // );
}
